<template>
  <swiper class="swiper section my-auto" :options="swiperOption">
    <swiper-slide class="card-ctn">
      <div class="neu-card">
        <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/neu/star.svg" white fullWidth shadow></base-icon>
      </div>
      <div class="subtitle">
        <p>Selecciona</p>
        <span>
          Selecciona las especialidades que desees (¡más de 40 disponibles!)
        </span>
      </div>
    </swiper-slide>
    <swiper-slide class="card-ctn">
      <div class="neu-card">
        <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/neu/price.svg" white fullWidth shadow></base-icon>
      </div>
      <div class="subtitle">
        <p>Servicios y horarios</p>
        <span>
          Elige los servicios y horarios<br>Videoconsulta, Consulta por Escrito, Chat, Llamada telefónica, etc.
        </span>
      </div>
    </swiper-slide>
    <swiper-slide class="card-ctn">
      <div class="neu-card">
        <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/neu/lock.svg" white fullWidth shadow class="my-auto">
        </base-icon>
      </div>
      <div class="subtitle">
        <p>Determina</p>
        <span>
          Determina los beneficiarios<br>Empleados, clientes, cónyuge/pareja, hijos, etc. (¡más de 40 disponibles!)
        </span>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/swiper-bundle.css'

  export default {
    name: 'swiper-example-centered-slides',
    title: 'Centered slides',
    components: {
      Swiper,
      SwiperSlide
    },
    data () {
      return {
        swiperOption: {
          slidesPerView: 1.5,
          spaceBetween: 90,
          centeredSlides: true,
          pagination: {
            el: '.swiper-pagination'
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'static-appopensalud/css/public/views/opensalud_empresas.scss';

  .swiper {
    width: 100%;

    .swiper-slide {
      display: flex;
      flex-direction: column;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/testing/SwiperTesting.vue